<template>
  <div class="page_under_maintenance background_neutral_white margin-bottom_sm">
    <SvgFactory
        name="icon_logo"
        :width="94"
      />
    <slot>
      <p class="bold-headline-h3-md typography-default py-5">
        Scheduled Maintenance Notice
      </p>
      <p class="bold-subtitle-md typography-default margin-bottom_sm text-center page_under_maintenance__container">
        We're fine-tuning our engines to serve you better! Our web & mobile app will be temporarily unavailable due to scheduled maintenance. We apologize for any inconvenience this may cause and appreciate your patience.
        <br />
        If you have any questions or need assistance, please reach out to us at support@iconnections.io.
        <br />
        Thank you for your understanding!
      </p>
    </slot>
  </div>
</template>

<script>
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';

export default {
  name: 'PageNotFound',
  components: {
    SvgFactory,
  },
};
</script>

<style lang="scss" scoped>
@import "@foundation";

.page_under_maintenance {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &__container {
    max-width: 1000px;
  }
}
</style>
